import Vue from 'vue';
import MsgBox from './msgBox';

let msgBox = null;

function getMsgBox() {
   if (!msgBox) {
      let msgClass = Vue.extend(MsgBox);
      let msg = new msgClass();
      msgBox = msg.$mount();
   }

   return msgBox;
}

function confirm(msgObj) {
   return getMsgBox().confirm(msgObj);
}


Vue.prototype.$msg = {
   confirm
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/@consigmais-team/vue-common/components/msgBox/index.js
// module id = tsAw
// module chunks = 0